import { useCallback, useMemo } from 'react';
import {
  useWbsProgramLabelSearchLazyQuery,
  WbsProgramLabelSearchQuery
} from 'graphql/types';
import { useNoteContext } from 'modules/notes/NoteContext';
import { CPT_LABEL_PAGE_COUNT } from '../components/constants';

export interface ProgramLabelSearchParams {
  query?: string;
}

export interface UseProgramLabelSearchResultProps {
  searchHandler: ({ query }: ProgramLabelSearchParams) => void;
  data: WbsProgramLabelSearchQuery | undefined;
  loading: boolean;
}

export const useProgramLabelSearch = (): UseProgramLabelSearchResultProps => {
  const { date } = useNoteContext();
  const [
    getProgramOptions,
    { data, loading }
  ] = useWbsProgramLabelSearchLazyQuery();

  const searchHandler = useCallback(
    ({ query }: ProgramLabelSearchParams) => {
      const variables = {
        date: date.toISODate(),
        input: {
          count: CPT_LABEL_PAGE_COUNT,
          query: query
        }
      };

      getProgramOptions({ variables });
    },
    [date, getProgramOptions]
  );

  return useMemo(
    () => ({
      searchHandler,
      data,
      loading
    }),
    [data, loading, searchHandler]
  );
};
export default useProgramLabelSearch;
